import React from 'react'

import {
  FieldSpec,
  LinkedPathField,
  PaginatedTable,
  RelatedLinkedField,
  UnitLocUnitField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  sku: { id: 'sku', label: 'SKU', ordering: 'sku__sku', renderer: RelatedLinkedField(ValueField, 'name') },
  client: {
    id: 'sku.client',
    label: 'Client',
    ordering: 'sku__account__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  product: { id: 'product', label: 'Product', ordering: 'product__name', renderer: RelatedLinkedField(ValueField, 'name') },
  batch: {
    id: 'batch',
    label: 'Batch',
    ordering: 'client_uid',
    renderer: RelatedLinkedField(ValueField, 'name')
  },
  numUnits: { id: 'numUnits', label: 'Number of Units', ordering: 'num_units', renderer: UnitLocUnitField },
  path: { id: 'objPath', label: 'Found', ordering: 'place__search_path', renderer: LinkedPathField },
}

export const FoundListTable = (props: ListTableProps) => {
  const { paginator, title, fields, exportConfig } = props

  return (
    <>
      <PaginatedTable
        title={title || 'Found'}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        exportConfig={exportConfig}
      />
    </>
  )
}
